import { UserId } from '../user/User';
import { tuple } from '../common/lang/tuple';

export const socketMessageNames = tuple(
    // Used in e.g. runtime validation
    'banner.notify',
    'emailProcessJobFailed',
    'emailProcessJobFinished',
    'imageProcessingPlannerCreated',
    'imageProcessJobFailed',
    'imageProcessJobFinished',
    'maintenance.notify',
    'mapGenerated',
    'ui.notify',
    'userNotification',
    'videoProcessJobFailed',
    'videoProcessJobFinished',
    'videoProcessJobProgress',
);

export type SocketMessageName = typeof socketMessageNames[number]; // Used in compile-type checking

/**
 * Used to attach the type of the message body to the event name. Useful when dealing with socket.on().
 */

export class SocketMessageEvent<_T> {
    public constructor(public name: SocketMessageName) {}
}

/**
 * The message data to send.
 */
export interface SocketMessage<T> {
    name: SocketMessageName;
    data: T;
}

export interface SocketSendResult {
    sent: boolean;
}

export interface ISendSocketMessageWorkflowInput {
    userId: UserId;
    message: SocketMessage<any>;
    acknowledgementRequired: boolean;
}
